export default __webpack_public_path__ + "static/media/recaptcha.f3f100c9.png";